export default __webpack_public_path__ + "static/media/Body_C2.f9f176c0.svg";